export default "__VITE_ASSET__VztOkdsG__"